import React, { useState } from "react";
import { useData } from "@/context/DataContext";
import { PageTitle, Fab, StickyTotal, RowActions, EmptyState } from "@/components/shared";
import DataDialog from "@/components/DataDialog";
import { formatRupiah, parseNumber } from "@/lib/format";
import { isBought } from "@/lib/compute";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function Life() {
  const { data, create, update, remove } = useData();
  const items = data.life_after_married || [];
  const payments = data.pembayaran || [];
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const total = items.reduce((s, i) => s + parseNumber(i.harga), 0);

  const fields = [
    { name: "kebutuhan", label: "Kebutuhan", type: "text", required: true },
    { name: "link_checkout", label: "Link Check Out (opsional)", type: "text" },
    { name: "harga", label: "Harga", type: "currency", required: true },
    { name: "keterangan", label: "Keterangan", type: "textarea" },
  ];

  const onSave = async (payload) => {
    if (editing) { await update("life_after_married", editing.id, payload); toast.success("Diperbarui"); }
    else { await create("life_after_married", payload); toast.success("Ditambahkan"); }
  };

  return (
    <div>
      <PageTitle title="Life After Married" subtitle="Kebutuhan setelah menikah" />
      <StickyTotal testId="life-total">
        <p className="text-xs uppercase tracking-wider text-muted-foreground">Total Harga</p>
        <p className="font-heading text-3xl font-semibold" data-testid="life-total-value">{formatRupiah(total)}</p>
      </StickyTotal>
      <div className="rounded-xl border border-border">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Kebutuhan</TableHead><TableHead>Link</TableHead><TableHead className="text-right">Harga</TableHead>
            <TableHead>Keterangan</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Aksi</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {items.map((i) => {
              const bought = isBought(i, payments, "life_after_married");
              return (
                <TableRow key={i.id} data-testid={`row-${i.id}`} className={bought ? "bg-green-500/15" : ""}>
                  <TableCell className="font-medium">{i.kebutuhan}</TableCell>
                  <TableCell>{i.link_checkout ? <a href={i.link_checkout} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-primary underline"><ExternalLink className="h-3 w-3" />Link</a> : "-"}</TableCell>
                  <TableCell className="text-right">{formatRupiah(i.harga)}</TableCell>
                  <TableCell className="text-muted-foreground">{i.keterangan || "-"}</TableCell>
                  <TableCell>{bought ? <Badge className="bg-green-600">Sudah dibeli</Badge> : <Badge variant="outline">Belum</Badge>}</TableCell>
                  <TableCell><RowActions id={i.id} onEdit={() => { setEditing(i); setOpen(true); }} onDelete={() => remove("life_after_married", i.id)} /></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {items.length === 0 && <EmptyState />}
      </div>
      <Fab testId="fab-life" onClick={() => { setEditing(null); setOpen(true); }} />
      <DataDialog open={open} onOpenChange={setOpen} title={editing ? "Edit Kebutuhan" : "Tambah Kebutuhan"} fields={fields} initial={editing} onSave={onSave} />
    </div>
  );
}
